module.exports = __webpack_public_path__ + "img/telegram.6b2e059f.svg";